import React, { useState } from "react"
import InputPlaceholderChipTemplate from "../../../components/molecules/InputPlaceholderChipTemplate.molecule"
import { generateRandomId } from "../../../utils/strings.utils"
import ClientChip from "../../../components/molecules/ClientChip.molecule"
import DropdownCustomFilterSearch from "../../../components/molecules/DropdownCustomFilterSearch.molecule"
import DropdownClientPicker from "../../../components/compounds/DropdownClientPicker.compound"

const DropdownClientInplace = ({
  value,
  onChange,
  label = "Proyecto",
  placeholder = "Proyecto",
  placeholderIcon = "pi pi-briefcase",
  name = "clientId",
  options,
  optionValue = "id",
  optionLabel = "name",
  error,
  dropdownRef,
  dropdownInputProps,
  readOnly = false,
  containerStyles = {
    width: "92px",
    height: "39px",
  },
  ...props
}) => {
  if (!options) return
  const [isEditing, setIsEditing] = useState(false)
  const selectedClient = options.find(
    (option) => option?.[optionValue] === value
  )
  const clientName = selectedClient?.[optionLabel] || ""

  options = options.filter((option) => {
    if (Object.keys(option).includes("active")) {
      return option[optionValue] === value || option.active
    }
    return option
  })
  if (value) {
    containerStyles = {
      ...containerStyles,
      height: "37px",
    }
  }
  const dropdownClientId = `dropdown-client-${name}-${generateRandomId()}`

  const handleChipClick = () => {
    setIsEditing(true)
    setTimeout(() => {
      dropdownRef.current?.show()
      dropdownRef.current?.getFocusInput().focus()
    }, 100)
  }

  const ClientProjectChipTemplate = () => {
    return (
      <div
        className="flex gap-2 align-items-center cursor-pointer"
        onClick={handleChipClick}
      >
        <ClientChip clientCode={selectedClient?.code} />
        <span
          style={{
            position: "absolute",
            top: "50%",
            left: "0",
            zIndex: "10",
            transform: "translate(46px, -50%)",
            whiteSpace: "nowrap",
          }}
          className="text-xl"
        >
          {selectedClient.name}
        </span>
      </div>
    )
  }

  const placeholderChipTemplate = () => {
    return (
      <InputPlaceholderChipTemplate
        disabled={readOnly}
        error={error}
        highlighted={isEditing}
        className="relative"
        template={
          <span className="p-chip-text text-overflow-ellipsis white-space-nowrap overflow-hidden max-w-12rem m-0">
            {value && clientName ?
              clientName
            : <span className="flex gap-2 align-items-center">
                {error ?
                  <i className="pi pi-exclamation-triangle text-xs line-height-2 m-auto"></i>
                : <i className="pi pi-briefcase text-xs line-height-2 m-auto"></i>
                }
                <span>{label}</span>
              </span>
            }
          </span>
        }
        onClick={handleChipClick}
        style={{
          width: "calc(100% - 2px)",
          height: "calc(100% - 2px",
        }}
      />
    )
  }
  return (
    <div
      className="dropdown-project-filter-inplace input-panel-with-chip"
      style={containerStyles}
    >
      {(clientName && value) || readOnly ?
        <ClientProjectChipTemplate />
      : placeholderChipTemplate()}
      {!readOnly && (
        <div className="field m-0">
          <DropdownClientPicker
            id={dropdownClientId}
            ref={dropdownRef}
            clients={options}
            className="opacity-0 h-2rem overflow-hidden absolute w-full pointer-events-none"
            panelStyle={{
              marginTop: "10px",
            }}
            optionValue={optionValue}
            optionLabel={optionLabel}
            selectedClient={value}
            setSelectedClient={(value) => {
              onChange({
                name,
                value,
              })
              setIsEditing(false)
            }}
            filter
            filterTemplate={(props) => (
              <DropdownCustomFilterSearch
                props={props}
                inputProps={{
                  autoFocus: true,
                }}
              />
            )}
            filterBy="code,name"
          />
        </div>
      )}
    </div>
  )
}

export default DropdownClientInplace
